import {
  ActorConnectionPoint,
  ActorConnectionPointType,
  ACTOR_CONNECTION_POINT_IN_NODE_DEF
} from "../utils/io/connections/Actor";
import { NodeParamsConfig, ParamConfig } from "../utils/params/ParamsConfig";
import { TRIGGER_CONNECTION_NAME, TypedActorNode } from "./_Base";
const CONNECTION_OPTIONS = ACTOR_CONNECTION_POINT_IN_NODE_DEF;
class TriggerTwoWaySwitchActorParamsConfig extends NodeParamsConfig {
  constructor() {
    super(...arguments);
    this.condition = ParamConfig.BOOLEAN(1);
  }
}
const ParamsConfig = new TriggerTwoWaySwitchActorParamsConfig();
const _TriggerTwoWaySwitchActorNode = class extends TypedActorNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
  }
  static type() {
    return "triggerTwoWaySwitch";
  }
  initializeNode() {
    super.initializeNode();
    this.io.inputs.setNamedInputConnectionPoints([
      new ActorConnectionPoint(TRIGGER_CONNECTION_NAME, ActorConnectionPointType.TRIGGER, CONNECTION_OPTIONS)
    ]);
    this.io.outputs.setNamedOutputConnectionPoints([
      new ActorConnectionPoint(_TriggerTwoWaySwitchActorNode.OUTPUT_NAME_IF_TRUE, ActorConnectionPointType.TRIGGER, CONNECTION_OPTIONS),
      new ActorConnectionPoint(_TriggerTwoWaySwitchActorNode.OUTPUT_NAME_IF_FALSE, ActorConnectionPointType.TRIGGER, CONNECTION_OPTIONS)
    ]);
  }
  receiveTrigger(context) {
    const condition = this._inputValueFromParam(this.p.condition, context);
    if (condition) {
      this.runTrigger(context, 0);
    } else {
      this.runTrigger(context, 1);
    }
  }
};
export let TriggerTwoWaySwitchActorNode = _TriggerTwoWaySwitchActorNode;
TriggerTwoWaySwitchActorNode.OUTPUT_NAME_IF_TRUE = `${TRIGGER_CONNECTION_NAME}IfTrue`;
TriggerTwoWaySwitchActorNode.OUTPUT_NAME_IF_FALSE = `${TRIGGER_CONNECTION_NAME}IfFalse`;
